import React from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

interface ComponentProps {
  title?: string;
}

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  title?: string;
  component: React.ComponentType<ComponentProps>;
  scopes?: string[];
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  title,
  component: Component,
  scopes,
  ...rest
}) => {
  const { user, hasScopes } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user && (scopes ? hasScopes(scopes) : true) ? (
          <Component title={title} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/app',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
